export default __webpack_public_path__ + "static/media/vocoretro.77b25de2.png";